export default __webpack_public_path__ + "static/media/hamza.647c4aac.jpg";